/*

  Returns info on load balanced nodes and retrieving info on where streams are active

*/
import { useState, useEffect } from "react";
//
const baseUri = "https://loadbalancer.stronk.rocks";

const useLoadBalancer = (props) => {
  // Whether the stream is active at any ingest location
  const [sourceLocation, setSource] = useState("");
  // Best node to connect with for this stream
  const [bestHost, setUri] = useState("");
  // Generic load balancer stats
  const [loadBalancerInfo, setLoadInfo] = useState(null);

  const getBalancer = () =>
    fetch(baseUri, {
      method: "GET",
    });

  const getSource = (source) =>
    fetch(baseUri + "/?source=" + source, {
      method: "GET",
    });

  const getNode = (stream) =>
    fetch(baseUri + "/" + stream, {
      method: "GET",
    });

  // Retrieve the best node to connect to once on load
  // refresh when the stream becomes (in)active
  useEffect(() => {
    const refresh = async () => {
      let nodeResp = await getNode(encodeURIComponent(props.streamName));
      if (nodeResp.ok) {
        let nodeData = await nodeResp.text();
        if (nodeData == "FULL") {
          setUri("");
        } else if (nodeData != bestHost) {
          setUri(nodeData);
        }
      }
    };
    refresh();
  }, [sourceLocation]);

  // Update load balancer and stream source info on an interval
  useEffect(() => {
    const refresh = async () => {
      let sourceResp = await getSource(encodeURIComponent(props.streamName));

      if (sourceResp.ok) {
        let sourceData = await sourceResp.text();
        if (sourceData == "FULL") {
          setSource("");
        } else {
          setSource(sourceData);
        }
      }
    };
    refresh();
    const interval = setInterval(refresh, 5000);
    return () => clearInterval(interval);
  }, []);

  // Update load balancer stats on an interval
  useEffect(() => {
    const refresh = async () => {
      let balancerResp = await getBalancer();

      if (balancerResp.ok) {
        setLoadInfo(await balancerResp.json());
      }
    };
    refresh();
    const interval = setInterval(refresh, 5000);
    return () => clearInterval(interval);
  }, []);

  return [bestHost, sourceLocation, loadBalancerInfo];
};

export default useLoadBalancer;
